import axios from 'axios'
import { urlApi } from '../config/env'

const api = axios.create({ baseURL: `${urlApi}` })

export { api }
